<template>
  <div class="basicInfor_left">
    <div v-if="skImgList && skImgList.length > 0">
      <!-- 轮播图 -->
      <div class="swiper_wrapper_con">
        <div class="box">
          <div class="swiper-box">
            <swiper ref="swiperTop" :options="swiperOptionTop" class="gallery-top">
              <swiper-slide v-for="item in skImgList" :key="item.id">
                <div class="swiper-item" style="width: 100%; height: 100%">
                  <div class="swiper-img" style="width: 100%; height: 100%">
                    <video v-if="item.fileSuffix === '.mp4'" :src="imgPrefix + item.fileName" class="swiper-show_video" controls="controls">
                      该内容不支持播放
                      <!-- @click="previewSwiperImg(imgPrefix + item.fileName, 'video')"  v-if="item.fileSuffix === '.mp4'" -->
                    </video>
                    <img
                      v-else
                      :src="imgPrefix + item.fileName"
                      alt=""
                      class="swiper-show_img"
                      style="width: 100%; cursor: pointer; height: 100%; object-fit: contain; background-color: #000"
                      @click.stop="doPriveImg()"
                    />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <swiper v-if="skImgList.length < 4" ref="swiperThumbs" :options="swiperOptionThumbs" class="gallery-thumbs" style="margin-top: 20px">
              <swiper-slide v-for="(item, index) in skImgList" :key="index">
                <video v-if="item.fileSuffix === '.mp4'" :src="imgPrefix + item.fileName" class="swiper-show_video" controls="controls">
                  该内容不支持播放
                </video>
                <img v-else :src="imgPrefix + item.fileName" class="swiper-show_img" style="" />
              </swiper-slide>
              <div slot="button-prev" class="swiper-thumbs-prev swiper-button-white">
                <svg
                  class="icon"
                  height="32"
                  p-id="3165"
                  t="1632625518037"
                  version="1.1"
                  viewBox="0 0 1024 1024"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M731.733333 480l-384-341.333333c-17.066667-14.933333-44.8-14.933333-59.733333 4.266666-14.933333 17.066667-14.933333 44.8 4.266667 59.733334L640 512 292.266667 821.333333c-17.066667 14.933333-19.2 42.666667-4.266667 59.733334 8.533333 8.533333 19.2 14.933333 32 14.933333 10.666667 0 19.2-4.266667 27.733333-10.666667l384-341.333333c8.533333-8.533333 14.933333-19.2 14.933334-32s-4.266667-23.466667-14.933334-32z"
                    fill="#999999"
                    p-id="3166"
                  ></path>
                </svg>
              </div>
              <div slot="button-next" class="swiper-thumbs-next swiper-button-white">
                <svg
                  class="icon"
                  height="32"
                  p-id="3459"
                  t="1632625587130"
                  version="1.1"
                  viewBox="0 0 1024 1024"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M384 512L731.733333 202.666667c17.066667-14.933333 19.2-42.666667 4.266667-59.733334-14.933333-17.066667-42.666667-19.2-59.733333-4.266666l-384 341.333333c-10.666667 8.533333-14.933333 19.2-14.933334 32s4.266667 23.466667 14.933334 32l384 341.333333c8.533333 6.4 19.2 10.666667 27.733333 10.666667 12.8 0 23.466667-4.266667 32-14.933333 14.933333-17.066667 14.933333-44.8-4.266667-59.733334L384 512z"
                    fill="#999999"
                    p-id="3460"
                  ></path>
                </svg>
              </div>
            </swiper>
            <swiper v-else ref="swiperThumbs" :options="swiperOptionThumbLop" class="gallery-thumbs" style="margin-top: 20px">
              <swiper-slide v-for="(item, index) in skImgList" :key="index">
                <video v-if="item.fileSuffix === '.mp4'" :src="imgPrefix + item.fileName" class="swiper-show_video" controls="controls">
                  该内容不支持播放
                </video>
                <img v-else :src="imgPrefix + item.fileName" class="swiper-show_img" style="" />
              </swiper-slide>
              <div slot="button-prev" class="swiper-thumbs-prev swiper-button-white">
                <svg
                  class="icon"
                  height="32"
                  p-id="3165"
                  t="1632625518037"
                  version="1.1"
                  viewBox="0 0 1024 1024"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M731.733333 480l-384-341.333333c-17.066667-14.933333-44.8-14.933333-59.733333 4.266666-14.933333 17.066667-14.933333 44.8 4.266667 59.733334L640 512 292.266667 821.333333c-17.066667 14.933333-19.2 42.666667-4.266667 59.733334 8.533333 8.533333 19.2 14.933333 32 14.933333 10.666667 0 19.2-4.266667 27.733333-10.666667l384-341.333333c8.533333-8.533333 14.933333-19.2 14.933334-32s-4.266667-23.466667-14.933334-32z"
                    fill="#999999"
                    p-id="3166"
                  ></path>
                </svg>
              </div>
              <div slot="button-next" class="swiper-thumbs-next swiper-button-white">
                <svg
                  class="icon"
                  height="32"
                  p-id="3459"
                  t="1632625587130"
                  version="1.1"
                  viewBox="0 0 1024 1024"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M384 512L731.733333 202.666667c17.066667-14.933333 19.2-42.666667 4.266667-59.733334-14.933333-17.066667-42.666667-19.2-59.733333-4.266666l-384 341.333333c-10.666667 8.533333-14.933333 19.2-14.933334 32s4.266667 23.466667 14.933334 32l384 341.333333c8.533333 6.4 19.2 10.666667 27.733333 10.666667 12.8 0 23.466667-4.266667 32-14.933333 14.933333-17.066667 14.933333-44.8-4.266667-59.733334L384 512z"
                    fill="#999999"
                    p-id="3460"
                  ></path>
                </svg>
              </div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no_img_wrapper">
      <div class="no_img">
        <img alt="" src="../../../../../assets/images/nodataImg.svg" />
      </div>
      暂无实勘,去
      <a-button type="link" @click="addImg('add')">上传</a-button>
    </div>
    <span v-if="skImgList && skImgList.length > 0" class="botText">
      <p>共{{ skImgList ? skImgList.length : 0 }}张照片</p>
      <p style="cursor: pointer" @click="showDownloadFile">下载图片</p>
      <!-- 当前登录为维护人或维护人所在店的店长 -->
      <p
        v-if="housesData && (housesData.accendantStoreLeaderId === uid || housesData.accendantId === uid)"
        style="cursor: pointer"
        @click="editImg('edit')"
      >
        编辑图片
      </p>
    </span>
  </div>
</template>
<script>
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

let vm = null;
export default {
  data() {
    return {
      imgPrefix: process.env.VUE_APP_OSS_URL,
      swiperOptionThumbs: {
        loop: false, // 循环模式选项
        // spaceBetween: 0,
        spaceBetween: 10,
        slidesPerView: 4,
        centeredSlides: true, // 设置活动块居中
        slideToClickedSlide: true,
        navigation: {
          prevEl: '.swiper-thumbs-next',
          nextEl: '.swiper-thumbs-prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.$refs.swiperTop.$swiper.slideToLoop(this.realIndex, 1000, false);
          }
        }
      },
      swiperOptionThumbLop: {
        loop: true, // 循环模式选项
        // spaceBetween: 0,
        spaceBetween: 10,
        slidesPerView: 4,
        centeredSlides: true, // 设置活动块居中
        slideToClickedSlide: true,
        navigation: {
          prevEl: '.swiper-thumbs-next',
          nextEl: '.swiper-thumbs-prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.$refs.swiperTop.$swiper.slideToLoop(this.realIndex, 1000, false);
          }
        }
      },
      swiperOptionTop: {
        loop: true, // 循环模式选项
        // autoplay: true, //自动循环
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。
        // spaceBetween: -100, // 在slide之间设置距离（单位px）。
        spaceBetween: 10,
        // centeredSlides: true, // 设置活动块居中
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        on: {
          slideChangeTransitionStart: function () {
            if (vm.$refs.swiperThumbs.$swiper !== undefined) {
              console.log(vm.$refs.swiperThumbs.$swiper.slideToLoop(this.realIndex, 1000, false));
            }
          }
        }
      },
      // 轮播
      swiperOption: {
        autoplay: true,
        speed: 3000,
        loop: true,
        slidesPerView: 3,
        watchSlidesVisibility: true, // 防止不可点击
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  mounted() {
    vm = this;
    console.log(this.imageUrls);
  },
  components: { Swiper, SwiperSlide },
  props: {
    housesData: {
      type: Object,
      default: () => {}
    },
    skImgList: {
      type: Array,
      default: () => []
    },
    uid: {
      type: Number | String,
      default: 0
    }
  },
  computed: {
    imageUrls() {
      return this.skImgList.map((item) => item.url);
    }
  },
  methods: {
    // 预览图片
    previewSwiperImg(url, type) {
      const obj = {
        showSwiperImg: true,
        swiperImgUrl: url,
        previewType: type
      };
      this.$emit('previewSwiperImg', obj);
    },
    addImg() {
      this.$emit('addImg');
    },
    editImg() {
      this.$emit('EditImg');
    },
    // 下载图片显示页面
    showDownloadFile() {
      this.$emit('showDownloadFile');
    },
    doPriveImg() {
      this.$viewerApi({
        images: this.imageUrls
      });
    }
  }
};
</script>
<style lang="less" scoped>
.botText {
  display: flex;
  width: 220px;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 10px;

  & > p {
    &:nth-of-type(1) {
      font-size: 14px;
      color: black;
    }

    &:nth-of-type(2) {
      font-size: 14px;
      color: var(--ThemeColor);
      font-weight: bold;
    }

    &:nth-of-type(3) {
      font-size: 14px;
      color: var(--ThemeColor);
      font-weight: bold;
    }
  }
}

.no_img_wrapper {
  width: 100%;
  height: 200px;
  text-align: center;
}

.no_img {
  width: 300px;
  height: 160px;
  background: #f2f2f2;
  margin: 20px auto 0 auto;

  img {
    width: 300px;
    height: 160px;
  }
}

.basicInfor_left {
  // width:710px;
  width: 58%;
  height: auto;

  .img_big {
    width: 710px;
    // height:400px;
    background: #f2f2f2;
    margin-bottom: 10px;
  }
}

.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-right: 20px;
  // cursor: pointer;
  height: 100%;

  .icon-i {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;

    .iconfont {
      font-size: 20px;
    }
  }

  .icon-ii {
    background-color: #31c170;
  }
}

.box {
  width: 100%;
  position: relative;
  background-color: #fff;
  /* padding-top: 40px; */
}

.swiper-container {
  position: relative;
}

.swiper-box {
  /* width: 960px; */
  width: 100%;
  margin: auto;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
  /* width: 82%; */
  width: 100%;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  /* opacity: 0.4; */
  opacity: 1;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

.swiper-slide {
  text-align: center;
  height: 350px;
  display: flex;
  transition: 300ms;
  /* transform: scale(0.6); */
  transform: scale(1);
  /* opacity: 0.3; */
  opacity: 1;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.swiper-slide-next {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
  z-index: 998 !important;
}

.swiper-slide-prev {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
}

.swiper-slide-active {
  opacity: 1;
  z-index: 999 !important;
}

.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
  --swiper-navigation-color: #999 !important;
  /* top: 330px; */
}

.gallery-thumbs .swiper-slide {
  height: 120px !important;
}

.gallery-thumbs .swiper-slide-active {
  border: 4px solid #006c95;
}

.swiper-thumbs-prev,
.swiper-thumbs-next {
  position: absolute;
  z-index: 99;
  top: 10px;
  width: 27px;
  height: 120px;
  background: rgba(0, 0, 0, 0.8);
}

.swiper-thumbs-next {
  left: 0px;
}

.swiper-thumbs-prev {
  right: 0px;
}

.bottom-box {
  width: 100%;
  height: 400px;
  position: relative;
  margin-top: 40px;
}

.bottom-b-img {
  width: 100%;
  height: 100%;
  position: absolute;
}

.bottom-b-color {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  background: rgba(0, 108, 149, 0.6);
  display: flex;
  align-items: center;
}

.bottom-img {
  width: 400px;
  height: 100px;
  margin: auto;
}

.swiper-slide[data-v-7292165a] {
  height: 370px;
}

.btn_more {
  color: black;
  text-align: center;
  /* border-bottom:1px solid #f2f2f2; */
}

.btn_more:hover {
  color: var(--ThemeColor);
}

.swiper-show_video,
.swiper-show_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
